(function() {
    'use strict';

    angular.module("order")
        .controller('PaymentImportController', PaymentImportController);

    PaymentImportController.$inject = ['$scope', 'operationTypeOptions', 'operationMessagesConst', 'orderDataSrvc', 'downloadLinkSrvc', 'notificationSrvc'];

    function PaymentImportController($scope, operationTypeOptions, operationMessagesConst, orderDataSrvc, downloadLinkSrvc, notificationSrvc) {
        var self = this;

        self.serverErrors = {}
        self.loading = false;
        self.filterData = {
            file: null,
            bank: null
        };
        self.paymentsData = null;
        self.unassignedCols = [{
            title: 'Tytuł przelewu',
            value: '0',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Kwota',
            value: '1',
            type: 'number',
            searchable: false,
            orderable: false
        }];
        self.assignedCols = [{
            title: 'Tytuł przelewu',
            value: '0',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Kwota',
            value: '1',
            type: 'number',
            searchable: false,
            orderable: false
        }, {
            title: 'Nr zamówienia',
            value: '2',
            type: 'text',
            searchable: false,
            orderable: false
        }];

        self.bankOptions = [
            {
                name: 'Santander Bank',
                value: 'santander'
            },
           {
                name: 'mBank',
                value: 'mbank'
            }
        ]

        self.operationTypeOptions = operationTypeOptions;

        self.importPayments = importPayments;
        self.cleanErrors = cleanErrors;
        $scope.inputFileChange = inputFileChange;

        activate();

        function activate() {
        }

        function importPayments() {
            if (self.filterData.file) {
                self.loading = true;
                orderDataSrvc.paymentsImport(self.filterData).$promise.then(
                    function (response) {
                        self.loading = false;
                        self.paymentsData = response;
                    },
                    function (response) {
                        self.loading = false;
                        self.serverErrors = response.data;
                        notificationSrvc.notification("error", operationMessagesConst.downloadError);
                    }
                )
            }
        }

        function inputFileChange(elem) {
            $scope.$apply(function () {
                if (elem.files.length) {
                    self.filterData.file = elem.files[0];
                } else {
                    self.filterData.file = null;
                }
            });

            cleanErrors('file')
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
